import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getEmployeeDelegation, clearSearchDelegationData } from "actions/delegationActions";
import messages from "components/messagesDescription";
import { injectIntl, intlShape, FormattedMessage } from "react-intl";
import {
  Card,
  CardSection,
  Toolbar,
  ToolbarSection,
  Button,
  Textfield,
  Loader,
} from "cxa-components";
import Pager from "components/pager";
import SearchEmployeeDelegationTable from "./SearchEmployeeDelegationTable";
import querystring from "querystring";
import _ from "lodash";
import { RouteMap } from "components/common/navigation/routeMap";

class SearchDelegationContainer extends Component {
  componentDidUpdate(prevProps) {
    const {
      query: { searchValue, pageSize, whichPage },
      query,
      getEmployeeDelegation,
    } = this.props;

    if (!_.isEqual(prevProps.query, query)) {
      getEmployeeDelegation({
        searchValue,
        pageSize,
        whichPage,
      });
    }
  }

  componentWillUnmount() {
    this.props.clearSearchDelegationData();
  }

  onSearchSubmit = e => {
    e.preventDefault();

    const searchValue = e.target.search.value;

    if (searchValue.length > 2) {
      this.updateQueryString({
        searchValue,
        pageSize: 10,
        whichPage: 1,
      });
    }
  };

  onAddEmployee = () => {
    this.props.push(RouteMap.AddEditDelegation);
  };

  onGoBack = () => {
    this.props.push(RouteMap.Delegation);
  };

  link = target => {
    const { match: { path }, query } = this.props;

    return `${path}?${querystring.stringify({ ...query, whichPage: target })}`;
  };

  updateQueryString = queryStr => {
    const { push } = this.props;
    const queryValue = querystring.stringify(queryStr);

    push(location.pathname + (queryValue.length > 0 ? "?" : "") + queryValue);
  };

  render() {
    const { intl, delegation: { search: { results }, isfetching, error } } = this.props;

    return (
      <div>
        <h2>{intl.formatMessage(messages.delegation.search.title)}</h2>
        <Card>
          <CardSection>
            <Toolbar>
              <ToolbarSection>
                <Button primary onClick={this.onGoBack} compact>
                  <FormattedMessage {...messages.delegation.employees.backToButton} />
                </Button>
              </ToolbarSection>
            </Toolbar>
            <Toolbar>
              <ToolbarSection className="apl-search__form">
                <form onSubmit={this.onSearchSubmit} className="form--search">
                  <p>
                    <input
                      boxed
                      size="80"
                      id="search"
                      name="search"
                      className="textfield textfield--boxed"
                      placeholder={intl.formatMessage(messages.searchTextDescription)}
                    />
                  </p>
                  <p>
                    <Button primary compact>
                      <FormattedMessage {...messages.searchTextDescription} />
                    </Button>
                  </p>
                </form>
              </ToolbarSection>
            </Toolbar>
            <p>
              <strong>{intl.formatMessage(messages.delegation.search.note)}: </strong>
              <FormattedMessage {...messages.delegation.search.notes} />
            </p>
            {isfetching && <Loader />}
            {!isfetching && (
              <SearchEmployeeDelegationTable onAddEmployee={this.onAddEmployee} results={results} />
            )}
            {!isfetching &&
              results.totalPageNumber > 1 && (
                <Pager
                  total={results.totalCount}
                  currentPage={results.currentPage}
                  pageSize={10}
                  link={this.link}
                />
              )}
            {!_.isEmpty(error) && (
              <div className="form__alert alert alert--error">
                {intl.formatMessage({
                  id: _.isString(error) ? error : error.message,
                  defaultMessage: _.isString(error) ? error : error.message,
                })}
              </div>
            )}
          </CardSection>
        </Card>
      </div>
    );
  }
}

SearchDelegationContainer.propTypes = {
  getEmployeeDelegation: PropTypes.func,
  delegation: PropTypes.object,
  push: PropTypes.func,
  query: PropTypes.object,
  clearSearchDelegationData: PropTypes.func,
  match: PropTypes.object,
  intl: intlShape.isRequired,
};

export default injectIntl(
  connect(
    state => ({
      delegation: state.delegation,
    }),
    {
      getEmployeeDelegation,
      clearSearchDelegationData,
    }
  )(SearchDelegationContainer)
);



// WEBPACK FOOTER //
// ./components/employee/delegation/SearchDelegationContainer.js